import { render, staticRenderFns } from "./PolTypeGrp.vue?vue&type=template&id=40f95911&"
import script from "./PolTypeGrp.vue?vue&type=script&lang=js&"
export * from "./PolTypeGrp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports